import { Pin } from "lucide-react";
import { cn } from "~/lib/utils";

/** A separate action: never address the session while changing its pin. */
export function SessionPin({
  label,
  pinned,
  onToggle,
}: {
  readonly label: string;
  readonly pinned: boolean;
  readonly onToggle: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={`${pinned ? "Unpin" : "Pin"} ${label}`}
      aria-pressed={pinned}
      title={pinned ? "Unpin session" : "Pin session"}
      data-session-pinned={pinned ? "" : undefined}
      className={cn(
        "flex size-5 shrink-0 items-center justify-center rounded text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring motion-reduce:transition-none",
        !pinned &&
          "pointer-events-none opacity-0 group-hover/session:pointer-events-auto group-hover/session:opacity-100 group-focus-within/session:pointer-events-auto group-focus-within/session:opacity-100 group-hover/row:pointer-events-auto group-hover/row:opacity-100 group-focus-within/row:pointer-events-auto group-focus-within/row:opacity-100",
      )}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      onDoubleClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.stopPropagation()}
    >
      <Pin aria-hidden="true" className={cn("size-3", pinned && "fill-current")} />
    </button>
  );
}
